module.exports = new __parcel__URL__("openportal.3d0f6dbf.png").toString();